var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    {
      tag: "component",
      class: { open: _vm.isOpen },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _vm._t("trigger", null, null, { isOpen: _vm.isOpen, toggle: _vm.toggle }),
      _vm._v(" "),
      _vm._t("collapsible", null, null, {
        isOpen: _vm.isOpen,
        toggle: _vm.toggle,
        close: _vm.close
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b80e284", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b80e284","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Collapsible.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0b80e284","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Collapsible.vue
// module chunks = 0